"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compoundWords = void 0;
const map_array_1 = require("../map-array");
const reduce_array_1 = require("../reduce-array");
const words_1 = require("../words");
exports.compoundWords = (value, transformer) => {
    const segments = words_1.words(value);
    if (segments === null) {
        return undefined;
    }
    return reduce_array_1.reduceArray(map_array_1.mapArray(segments, (word) => word.toLowerCase()), transformer, "");
};
//# sourceMappingURL=compound-words.js.map